module.exports = __webpack_public_path__ + "static/media/TrueFire_logo_black.c54e666d.png";